import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Datatable from '../../../../components/common/datatable/index';
import Can from '../../../../components/common/guards/can';
import { resubmitSubmissions } from '../../../../actions/submissions';
import ResubmitConfirmDialog from './resubmit-confirm-dialog';

class SubmissionsTable extends Component {
  state = {
    submissionToResubmit: null,
  };

  showResubmissionConfirm = (submissionId) => {
    this.setState({
      submissionToResubmit: submissionId,
    });
  }

  handleResubmission = (resubmit) => {
    if (resubmit) {
      this.props.dispatch(resubmitSubmissions(this.state.submissionToResubmit));
    }

    this.setState({
      submissionToResubmit: null,
    });
  }

  editLink = (row) => {
    const { isTeamRoute, isAuditRoute} = this.props;
    let path = 'admin';
    let text = row.attributes && row.attributes['audit-completed'] ? 'View' : 'View/Edit';
    let action = 'update';

    if (isAuditRoute) {
      path = 'admin/audit';
      text = row.attributes.auditable ? 'Audit' : 'View';
      action = 'audit';
    } else if (isTeamRoute) {
      path = 'team';
    }

    return (
      <Can action={action} subjectClass='Submission'>
        <a
          target="_blank"
          href={`/${path}/submissions/${row.id}`}
          className="red-ghost-btn btn btn-default"
        >
          { text }
        </a>
      </Can>
    );
  }

  render() {
    const {
      submissions, currentPage, onPageChange, onCheckboxClick, paging, isTeamRoute, isAuditRoute
    } = this.props;
    const { submissionToResubmit } = this.state;
    const dataToDisplay = (submissions || []);

    const actions = [
      (index, row) => (
        <div>
          {this.editLink(row)}
          {!isTeamRoute && !isAuditRoute && (
            <Can action='handle' subjectClass='Submission'>
              <a
                onClick={() => this.showResubmissionConfirm(row.id)}
                className="red-ghost-btn btn btn-default"
                disabled={!row.attributes['postcodeplan-objectives-id'] || row.attributes.status !== 'DECLINED'}
              >
                Resubmit
              </a>
            </Can>
          )}
        </div>
      )
    ];

    const columns = [
      {
        prop: 'outlet-code',
        title: 'Outlet code'
      },
      {
        prop: 'type',
        title: 'Type'
      },
      {
        prop: 'created-at',
        title: 'Upload date'
      },
      {
        prop: 'status',
        title: 'Status',
        format(data, row) {
          return (
            <div>
              {row.attributes.type === 'NGP' && row.attributes.status === 'APPROVED' ? 'VALIDATED' : data}
              &nbsp;
              { row.attributes.status === 'DECLINED' && row.attributes['decline-reason'] && (
                <OverlayTrigger
                  overlay={(
                    <Tooltip className="tooltip grey" id="tooltip">
                      {row.attributes['decline-reason']}
                    </Tooltip>
                  )}
                  placement="right"
                >
                  <Glyphicon glyph="info-sign"/>
                </OverlayTrigger>
              )}
            </div>
          );
        }
      },

      {
        prop: 'rdr-code',
        title: 'RDR'
      },
      {
        prop: 'abm-code',
        title: 'ABM'
      }
    ];

    if (!isAuditRoute) {
      columns.push({
        prop: '',
        title: '',
        format: (data, row) => {
          const { attributes } = row;
          const postcodeplanObjectiveId = attributes['postcodeplan-objectives-id'];
          const isDisabled = (!!postcodeplanObjectiveId && ['PENDING', 'APPROVED', 'DECLINED', 'VALIDATED'].includes(attributes.status)) ||
                    !(!!postcodeplanObjectiveId && ['QUERIED', 'PRE-VALIDATED'].includes(attributes.status));

          return (
            <Checkbox disabled={isDisabled} onClick={() => onCheckboxClick(row.id)} />
          );
        }
      }, {
        prop: 'audit-completed',
        title: 'Audit completed',
        format: data => (data === true ? 'Y' : 'N')
      });
    } else {
      columns.push({
        prop: 'savi-auditor-id',
        title: 'Savi auditor ID'
      });
    }

    return (
      <div>
        <div className="mg-bottom-30">
        </div>
        <Datatable
          data={dataToDisplay}
          columns={columns}
          actions={actions}
          hideId={false}
          remote
          dataSize={paging ? paging.number * paging.size : dataToDisplay.length}
          pagination={{
            page: currentPage,
            sizePerPage: 20,
            onPageChange,
          }}
        />
        {submissionToResubmit && <ResubmitConfirmDialog onClose={this.handleResubmission} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isTeamRoute: state.router.location.pathname.includes('team'),
  isAuditRoute: state.router.location.pathname.includes('audit'),
});

export default connect(mapStateToProps)(SubmissionsTable);



// WEBPACK FOOTER //
// ./src/components/admin/submissions/list/submissions-table.jsx